export const ROUTE_LOGIN = '/login'
export const ROUTE_SOCIAL_MONITOR = '/social-monitor'
export const ROUTE_SOCIAL_MONITOR_ID = (id) => `/social-monitor?id=${id}`
export const ROUTE_VERBATIM_MANAGEMENT = '/verbatim-management'
export const ROUTE_KEYWORD_MANAGEMENT = '/keyword-management'
export const ROUTE_NEW_AGGREGATION = '/new-aggregation'
// export const ROUTE_QUESTION_MANAGEMENT = '/question-management'
export const ROUTE_QUESTION_MANAGEMENT = '/question-management'
export const ROUTE_SUB_QUESTION_MANAGEMENT = '/sub-question-management'
// export const ROUTE_QUESTION_MANAGEMENT = '/question-management/question1'

export const ROUTE_USER_MANAGEMENT = '/user-management'
export const ROUTE_ADMIN_TOOL = '/admin-tool'
